export default class Environment {
    static nodeEnv = process.env.NODE_ENV
    static apiUri = process.env.REACT_APP_API
    static token = process.env.REACT_APP_TOKEN_API
}